module.exports = __webpack_public_path__ + "static/img/bg-4.c08b1277.png";